import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { PropsWithChildren } from 'react'
import Image from 'next/image'
import { assets } from '@/ui/assets'
import { Info } from '@/ui/molecules/info/Info'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { cn } from '@/ui/utils/style'

interface Props {
  points?: NormalizedUnitNumber
  userRank?: number
}

export function SummaryPanel({ points, userRank }: Props) {
  return (
    <Panel.Wrapper className="flex flex-1 justify-between gap-2 px-9 py-11">
      <div className="flex-shrink-0 flex-grow basis-1/2 py-0.5">
        <SummaryItem label="Your points">
          <div className="flex items-center gap-2">
            <div className="w-8">
              <Image src={assets.hypurrPawNoShadow} alt="" width={32} height={32} className="block" />
            </div>

            <Typography variant="h3" gradient gradientLayoutReset className="flex items-center gap-1 font-semibold text-4xl">
              {points
                ? Number(points).toLocaleString(undefined, {
                    minimumFractionDigits: points.eq(0) ? 0 : 2,
                    maximumFractionDigits: 2,
                  })
                : '0'}
            </Typography>
          </div>
        </SummaryItem>
      </div>

      <div className="flex-grow basis-1/2">
        <SummaryItem label="Your Rank">
          <div className="flex items-center">
            <Typography
              variant="h3"
              className={cn('flex items-center font-semibold text-4xl', { 'pt-2 text-2xl': !userRank })}
            >
              {userRank || 'Unranked'}
            </Typography>
          </div>
        </SummaryItem>
      </div>
    </Panel.Wrapper>
  )
}

// function RankChangeIcon({ rankChange }: { rankChange?: RankChange }) {
//   if (!rankChange || rankChange === 'no-change' || rankChange === 'unavailable') {
//     return null
//   }

//   if (rankChange === 'increase') {
//     return <MoveUp className="h-6 w-6 text-green-500" />
//   }

//   return <MoveDown className="h-6 w-6 text-red-500" />
// }

function SummaryItem({ label, info, children }: { label: string; info?: string } & PropsWithChildren) {
  return (
    <div className="flex flex-col items-start gap-1">
      <div className="flex items-center gap-1">
        <span className="font-semibold text-muted-foreground text-xs">{label}</span>
        {info && <Info>{info}</Info>}
      </div>
      {children}
    </div>
  )
}
